module.exports = __webpack_public_path__ + "static/media/mainFitting.57c9dbc7.svg";